module.exports = __webpack_public_path__ + "img/jiankong1.3744aac1.jpg";